module.exports = __webpack_public_path__ + "static/media/fill_63.8a5109e9.svg";